import { Injectable } from '@angular/core';
import { HttpClient } from './http-client.service';
import { TicketQuota, TicketQuotaMessage } from '../../models';
import { Logger } from '../logger.service';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { JwtHelper } from 'angular2-jwt';
import { OauthHelper } from './oauth-helper.service';

@Injectable()
export class TicketQuotaApi {

	private ticketQuotaRepo: string = "/api/events/v2/ticketQuotas";

	constructor(private httpClient: HttpClient, private logger: Logger, private jwtHelper: JwtHelper, private oauthHelper: OauthHelper) {
	}

	public getTicketQuotas(url: string): Observable<any> {
		return this.httpClient.get(url)
				.map(response => response.json())
	}

	public createTicketQuota(ticketQuota: TicketQuota): Observable<TicketQuota>  {
		let body = JSON.stringify(ticketQuota);
		let  observable: Observable<TicketQuota> = this.httpClient.post(this.ticketQuotaRepo, body)
			.map(response => <TicketQuota>response.json())
		return observable;
	}

	public linkTicketQuota(collectionUrl: string, ticketQuotaUrls: string[]) {
		return this.httpClient.putRef(collectionUrl, ticketQuotaUrls)
	}

	public updateTicketQuota(ticketQuota: TicketQuota): Observable<TicketQuota> {
		let obj: TicketQuota = Object.assign({}, ticketQuota);
		delete obj.ticketQuotaStatus;  // das ist Read-Only
		let body = JSON.stringify(obj);

		return this.httpClient.patch(ticketQuota._links.self.href, body)
			.map(response => ticketQuota)
	}

	public deleteTicketQuota(ticketQuotaToBeDeleted: TicketQuota) {
		return this.httpClient.delete(ticketQuotaToBeDeleted._links.deleteWithReference.href)
	}

	public loadTicketQuotaMessages(url: string): Observable<TicketQuotaMessage[]> {
		return this.httpClient.get(url)
				.map(response => response.json()._embedded.ticketQuotaMessages)
	}

	public postTicketQuotaMessage(url: string, ticketQuotaMessage: TicketQuotaMessage): Observable<TicketQuota> {
		let body = JSON.stringify(ticketQuotaMessage);
		let  observable: Observable<TicketQuota> = this.httpClient.post(url, body)
			.map(response => <TicketQuota>response.json())
		return observable;
	}

	public getTicketQuota(ticketQuotaId: string): Observable<TicketQuota> {
		return this.httpClient.get(this.ticketQuotaRepo + '/' + ticketQuotaId)
				.map(response => <TicketQuota>response.json())
	}
}



// WEBPACK FOOTER //
// ./src/app/services/webservice/ticketquota-api.service.ts